import { CLEAR_USER_LIKES } from '../../actions/clear-user-likes';
import { FETCH_USER_LIKES_SUCCESS } from '../../actions/fetch-likes-by-user';
import { DELETE_COMMENT_SUCCESS } from '../../actions/delete-comment';
import { DELETE_POST_SUCCESS } from '../../actions/delete-post';

export default (state = { count: 0 }, action = {}) => {
  switch (action.type) {
    case CLEAR_USER_LIKES:
      return { count: 0 };
    case FETCH_USER_LIKES_SUCCESS:
      return { count: action.meta.count };
    case DELETE_COMMENT_SUCCESS:
    case DELETE_POST_SUCCESS:
      return { count: state.count - 1 };
    default:
      return state;
  }
};
